// ChangePasswordModalAdmin.jsx
import React, { useContext, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../../Context/UserContext.js";



   export default function ChangePasswordModalAdmin({id}) {
      const [showPassword , setShowPassword] = useState(false) ;
      const {userToken } = useContext(UserContext) ;
      const closeBtnRef = useRef() ;


      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }


      const handleSubmit = async(values, { resetForm }) => {
         console.log("تم الإرسال:", values);
         await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/${id}` , values , {headers:header})
         .then(({data})=>{
            if(data.message === "success"){
               toast.success("Change Password Successfully ")
            }
         })
         .catch((error)=>{
            toast.error(error.response.data.message)
         })
         resetForm();
         closeBtnRef.current.click() ;
      };


      const initialValues = {
         password: "",
         rePassword: "",
      };
      const validationSchema = Yup.object({
         password: Yup.string()
            .min(6, "يجب أن تكون على الأقل 6 حروف")
            .required("كلمة المرور الجديدة مطلوبة")
            .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{8,}$/ , "Should be Password Start UpperCase And Contain 8 Character And Contain any (@#$%&*)"),
         rePassword: Yup.string().oneOf([Yup.ref("password"), null], "كلمة المرور غير متطابقة").required("تأكيد كلمة المرور مطلوب"),
      });


      return (
            <div className="ChangePasswordModalAdmin-container">
               <div className="modal fade" id="ChangePasswordModalAdmin" tabIndex="-1" aria-labelledby="ChangePasswordModalAdminLabel" aria-hidden="true">
                  <div className="modal-dialog">
                     <div className="modal-content">

                        <div className="modal-header">
                           <h5 className="modal-title" id="ChangePasswordModalAdminLabel">تغيير كلمة المرور</h5>
                           <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                        </div>

                        <div className="modal-body">
                           <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                              <Form>
                                 <div className="mb-3 position-relative">
                                    <label className="form-label">كلمة المرور الجديدة</label>
                                    <Field type={showPassword ? "text" : "password"} name="password" className="form-control  " />
                                    {showPassword ? (
                                          <i className="fas fa-eye toggle-password " onClick={() => setShowPassword(false)}></i>
                                       ) : (
                                          <i className="fas fa-eye-slash toggle-password " onClick={() => setShowPassword(true)}></i>
                                       )
                                    }
                                    <div className="text-danger"><ErrorMessage name="password" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">تأكيد كلمة المرور الجديدة</label>
                                    <Field  type={showPassword ? "text" : "password"}  name="rePassword" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="rePassword" /></div>
                                 </div>

                                 <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary">تغيير</button>
                                 </div>
                              </Form>
                           </Formik>
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         );
   }
